import { render, staticRenderFns } from "./News.vue?vue&type=template&id=258bfe70&"
import script from "./News.js?vue&type=script&lang=js&"
export * from "./News.js?vue&type=script&lang=js&"
import style0 from "./News.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports